// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hsPTcg73ZroSgqTufeC4{width:100%;display:flex}.sSwerAk6C3grzx4bwNlD{padding:2px 0;font-size:13px;font-style:normal;font-weight:500;line-height:normal}.l4tllPXj6c4xyk4bTAE3{color:var(--content-brand-primary);font-weight:500;text-decoration:none}.l4tllPXj6c4xyk4bTAE3:hover{color:var(--content-brand-secondary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionsWrap": `hsPTcg73ZroSgqTufeC4`,
	"button": `sSwerAk6C3grzx4bwNlD`,
	"learnMoreLink": `l4tllPXj6c4xyk4bTAE3`
};
export default ___CSS_LOADER_EXPORT___;
